
export default {
    props: ["placeholder", "options", "icon", "width"],
    methods: {
        handleChange(value) {
            console.log(`selected ${value}`)
        }
    }
}
